import { FiTarget, FiZap, FiTrendingUp, FiUsers } from 'react-icons/fi'
import type { CeptOutcome } from '@/types/about'

export const ceptModel: CeptOutcome[] = [
  {
    key: 'create',
    letter: 'C',
    title: 'Create Opportunities',
    description:
      'We develop platforms and initiatives that unlock potential, broaden access, and encourage participation.',
    Icon: FiTarget,
  },
  {
    key: 'empower',
    letter: 'E',
    title: 'Empower Individuals',
    description:
      'We provide the knowledge, mentorship, resources, and support people need to pursue their aspirations and contribute meaningfully to society.',
    Icon: FiZap,
  },
  {
    key: 'promote',
    letter: 'P',
    title: 'Promote Growth',
    description:
      'We celebrate achievements, encourage innovation, and expand access to opportunities that strengthen individuals, organisations, and communities.',
    Icon: FiTrendingUp,
  },
  {
    key: 'transform',
    letter: 'T',
    title: 'Transform Communities',
    description:
      'We contribute to sustainable social and economic progress through collective action, inclusive development, and long-term partnerships.',
    Icon: FiUsers,
  },
]
